import { Checkbox } from '../../components/ui/checkbox';
import { Button } from '../../components/ui/button';
import { useEffect, useRef } from 'react';

const SettingsDropdown = ({
  showSettingsDropdown,
  setShowSettingsDropdown,
  handleApplySettings,
  handleClearAll,
  tempShowAttemptAnalysis,
  setTempShowAttemptAnalysis,
  tempQuestionSolutionMode,
  setTempQuestionSolutionMode,
}) => {
  const dropdownRef = useRef(null);
  useEffect(() => {
    if (!showSettingsDropdown) return;
    const user = JSON.parse(localStorage.getItem('userProfile') || '{}');

    const handleClickOutside = (e) => {
      if (!user?.questionSolutionModeTourDone) {
        return;
      }
      // If clicked target is not inside dropdown AND not the settings button
      const clickedInsideDropdown = dropdownRef.current?.contains(e.target);
      const clickedSettingsButton = e.target.closest('.settings-button-target');

      if (!clickedInsideDropdown && !clickedSettingsButton) {
        setShowSettingsDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showSettingsDropdown]);

  if (!showSettingsDropdown) return null;

  return (
    <div
      ref={dropdownRef}
      className="
        absolute top-full right-0 mt-2
        w-[80vw] max-w-[393px]
        bg-[var(--q3-surface-default)]
        border border-[var(--q3-stroke-normal)]
        rounded-[20px]
        shadow-[0_25px_50px_-12px_rgba(0,0,0,0.25)]
        flex flex-col items-start
        z-50
      "
    >
      <div className="p-4 sm:p-3 w-full">
        {/* Show Attempt Analysis */}
        <div
          className="flex items-center justify-between mb-4 sm:mb-3 cursor-pointer"
          onClick={() => setTempShowAttemptAnalysis((prev) => !prev)}
        >
          <div className="flex items-center gap-2 sm:gap-1">
            <div onClick={(e) => e.stopPropagation()}>
              <Checkbox
                checked={tempShowAttemptAnalysis}
                onCheckedChange={setTempShowAttemptAnalysis}
                className="cursor-pointer"
              />
            </div>
            <span className="text-sm sm:text-xs text-[var(--q3-neutral-default)]">Show Attempt Analysis</span>
          </div>
        </div>

        {/* Question Solution Mode */}
        <div
          className="flex sm:mb-6 mb-4 question-solution-mode-target cursor-pointer"
          onClick={() => setTempQuestionSolutionMode((prev) => !prev)}
        >
          {/* Checkbox vertically centered */}
          <div className="flex items-center mr-2" onClick={(e) => e.stopPropagation()}>
            <Checkbox
              checked={tempQuestionSolutionMode}
              onCheckedChange={setTempQuestionSolutionMode}
              className="cursor-pointer"
            />
          </div>
          {/* Two lines stacked */}
          <div className="flex flex-col">
            <span className="text-sm sm:text-xs text-[var(--q3-neutral-default)] leading-tight">
              Question Solution Mode
            </span>

            <span className="text-sm sm:text-xs text-[var(--q3-neutral-light)] leading-tight">
              See the solution when you reopen the question.
            </span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-between w-full">
          <Button
            className="
              ml-[-4px] underline 
              !bg-[var(--q3-surface-default)] 
              !text-[var(--q3-neutral-default)]
              text-xs sm:text-sm
            "
            onClick={handleClearAll}
          >
            Clear All
          </Button>

          <Button
            className="
              !bg-[var(--q3-neutral-default)]
              !text-[var(--q3-neutral-default_inverted)]
              rounded-full
              flex
              w-[120px]
              h-[32px]
              min-w-[32px]
              min-h-[32px]
              max-h-[32px]
              px-2
              py-1
              justify-center
              items-center
              gap-0
              text-xs sm:text-sm
            "
            onClick={handleApplySettings}
          >
            Apply
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SettingsDropdown;
